// extracted by mini-css-extract-plugin
module.exports = {"container":"Stats_container__xZB2L","header":"Stats_header__xc7_E","stats":"Stats_stats__APNhH","number":"Stats_number__q6xTY","text":"Stats_text__I4X6h"};